import { User, Users, CreditCard, FileCheck, Calendar } from 'lucide-react';

export const API_BASE = `${(process.env.REACT_APP_BACKEND_URL || '').replace(/\/$/, '')}/api/v1`;

export const DEFAULT_FC = {
  steps: { slot: true, sepa: true },
  texts: {
    step_subject_title: 'Fach und Unterrichtsform',
    step_student_title: 'Teilnehmer:in',
    step_guardian_title: 'Erziehungsberechtigte:r',
    step_slot_title: 'Verfügbarkeit',
    step_payer_title: 'Zahlung und Adresse',
    step_payer_hint: 'Diese Person erhält die Rechnungen und unterschreibt das SEPA-Mandat.',
    step_sepa_title: 'Lastschriftmandat',
    step_sepa_hint: 'Mit der Erteilung des Mandats ermächtigen Sie die Musikschule, Zahlungen per Lastschrift von Ihrem Konto einzuziehen.',
    step_summary_title: 'Prüfen und absenden',
    submit_button: 'Anmeldung absenden',
    submit_legal_hint: 'Mit dem Absenden kommt noch kein Unterrichtsvertrag zustande. Sie erhalten eine E-Mail zur Bestätigung Ihrer Adresse. Anschließend prüft die Musikschule die Anmeldung.',
  },
  fields: {},
  custom_fields: [],
};

export const FIELD_DEFAULTS = {
  'student.category': { visible: true, required: true, label: 'Kategorie' },
  'student.instrument': { visible: true, required: true, label: 'Fach' },
  'student.lesson_type': { visible: true, required: true, label: 'Unterrichtsform' },
  'student.first_name': { visible: true, required: true, label: 'Vorname Schüler:in' },
  'student.last_name': { visible: true, required: true, label: 'Nachname Schüler:in' },
  'student.birthdate': { visible: true, required: true, label: 'Geburtsdatum' },
  'student.salutation': { visible: true, required: false, label: 'Anrede' },
  'student.title': { visible: true, required: false, label: 'Titel' },
  'student.gender': { visible: true, required: true, label: 'Geschlecht' },
  'student.email': { visible: true, required: false, label: 'E-Mail' },
  'student.phone': { visible: true, required: false, label: 'Rufnummer' },
  'student.prior_knowledge': { visible: true, required: false, label: 'Vorkenntnisse' },
  'student.photo_consent': { visible: true, required: false, label: 'Foto-Erlaubnis' },
  'student.notes': { visible: true, required: false, label: 'Anmerkungen' },
  'payer.first_name': { visible: true, required: true, label: 'Vorname' },
  'payer.last_name': { visible: true, required: true, label: 'Nachname' },
  'payer.salutation': { visible: true, required: false, label: 'Anrede' },
  'payer.title': { visible: true, required: false, label: 'Titel' },
  'payer.address_extra': { visible: true, required: false, label: 'Zusatz' },
  'payer.district': { visible: true, required: false, label: 'Ortsteil' },
  'payer.gender': { visible: true, required: false, label: 'Geschlecht' },
  'payer.birthdate': { visible: true, required: false, label: 'Geburtsdatum' },
  'payer.email': { visible: true, required: true, label: 'E-Mail' },
  'payer.phone': { visible: true, required: true, label: 'Rufnummer' },
  'payer.street': { visible: true, required: true, label: 'Straße' },
  'payer.house_number': { visible: true, required: true, label: 'Hausnr.' },
  'payer.postal_code': { visible: true, required: true, label: 'PLZ' },
  'payer.city': { visible: true, required: false, label: 'Ort' },
  'sepa.bic': { visible: false, required: false, label: 'BIC' },
};

export const STEP_ICONS = { student: User, guardian: Users, slot: Calendar, payer: Users, sepa: CreditCard, summary: FileCheck };

export const GROUP_PRIORITY_OPTIONS = [
  { value: 'add_students', label: 'Ich möchte weitere Schüler für den Gruppenunterricht anmelden' },
  { value: 'waitlist', label: 'Nein, ich möchte Gruppenunterricht und warte auf einen weiteren passenden Schüler' },
  { value: 'switch_20min', label: 'Ja, ich möchte sofort starten und wähle zunächst 20 Min Einzelunterricht' },
];

export const EMPTY_FORM = {
  student: {
    salutation: '', title: '', first_name: '', last_name: '',
    birth_day: '', birth_month: '', birth_year: '',
    category: '', lesson_type: '', instrument: '', notes: '',
    gender: '', email: '', phone: '',
    prior_knowledge: '', photo_consent: false,
    same_as_payer: false,
    address_same: true,
    street: '', house_number: '', address_extra: '',
    postal_code: '', city: '', district: '',
  },
  group: { priority: '', additional_students: [] },
  guardian: {
    same_as_payer: true, salutation: '', title: '', first_name: '', last_name: '',
    gender: '', birth_day: '', birth_month: '', birth_year: '', email: '', phone: '',
    address_same: true, street: '', house_number: '', address_extra: '', postal_code: '', city: '', district: '',
  },
  teaching_type: '',
  course_offer: null,
  location_id: '',
  preferred_slot: null,
  availability: [{ weekday: '', from: '', to: '' }],
  fallback_contact: false,
  phone_verification: null,
  payer: {
    salutation: '', title: '', first_name: '', last_name: '', email: '', phone: '',
    additional_phones: [],
    street: '', house_number: '', address_extra: '', postal_code: '', city: '', district: '',
    gender: '', birth_day: '', birth_month: '', birth_year: '', country: 'Deutschland',
  },
  sepa: { account_holder: '', different_holder: false, iban: '', bic: '', mandate_acknowledged: false },
  muensterland_card: { has_card: false, number: '' },
  consents: { agb: false, datenschutz: false, widerruf: false },
  custom: {},
};

export const SALUTATIONS = ['An', 'Eheleute', 'Familie', 'Firma', 'Frau', 'Herrn'];
export const TITLES = ['Dr.', 'Prof.', 'Prof. Dr.'];
export const GENDERS = ['männlich', 'weiblich', 'divers', 'ohne Angabe'];
export const MONTHS_DE = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];

export const AVAILABILITY_META = {
  free: { label: 'Plätze frei', active: 2, color: 'bg-emerald-600' },
  few: { label: 'Wenige Plätze', active: 1, color: 'bg-brand-warning' },
  full: { label: 'Belegt / Warteliste', active: 0, color: 'bg-rose-500' },
};
